var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, IconButton } from '@mui/material';
import SelectDD from '../FormComponents/SelectDD';
import CloseIcon from '@mui/icons-material/Close';
import UploadIcon from '../icons/UploadIcon';
import SuccessCheckIcon from '../icons/SuccessCheckIcon';
var UploadDocumentDialog = function (_a) {
    var _b;
    var _c = _a.open, open = _c === void 0 ? false : _c, onClose = _a.onClose, onUpload = _a.onUpload, documentTypes = _a.documentTypes, _d = _a.allowedExtensions, allowedExtensions = _d === void 0 ? ['docx', 'xlsx', 'pdf', 'jpeg', 'jpg'] : _d, _e = _a.dialogTitle, dialogTitle = _e === void 0 ? "Upload Document" : _e, _f = _a.uploadButtonLabel, uploadButtonLabel = _f === void 0 ? "Upload Document" : _f, _g = _a.cancelButtonLabel, cancelButtonLabel = _g === void 0 ? "Cancel" : _g, _h = _a.successTitle, successTitle = _h === void 0 ? "Upload Successful!" : _h, _j = _a.successMessage, successMessage = _j === void 0 ? "Your document has been uploaded successfully." : _j, _k = _a.showDocumentType, showDocumentType = _k === void 0 ? true : _k, _l = _a.multiple, multiple = _l === void 0 ? false : _l;
    var _m = useState([]), selectedFiles = _m[0], setSelectedFiles = _m[1];
    var _o = useState(''), docType = _o[0], setDocType = _o[1];
    var _p = useState(false), showSuccess = _p[0], setShowSuccess = _p[1];
    var _q = useState(null), fileError = _q[0], setFileError = _q[1];
    var _r = useState(false), isUploading = _r[0], setIsUploading = _r[1];
    var supportedFormatsText = allowedExtensions.map(function (ext) { return ext.toUpperCase(); }).join(', ');
    var MAX_FILE_SIZE = 25 * 1024 * 1024;
    var validateFile = function (file) {
        var fileName = file.name.toLowerCase();
        var extension = fileName.split('.').pop() || '';
        if (!allowedExtensions.includes(extension)) {
            setFileError("Unsupported file format. Please upload: ".concat(supportedFormatsText));
            return false;
        }
        if (file.size > MAX_FILE_SIZE) {
            setFileError('File size exceeds 25MB. Please upload a smaller file.');
            return false;
        }
        setFileError(null);
        return true;
    };
    var handleFileChange = function (e) {
        if (e.target.files) {
            var filesArray = Array.from(e.target.files);
            var validFiles_1 = [];
            var hasError = false;
            for (var _i = 0, filesArray_1 = filesArray; _i < filesArray_1.length; _i++) {
                var file = filesArray_1[_i];
                if (validateFile(file)) {
                    validFiles_1.push(file);
                }
                else {
                    hasError = true;
                }
            }
            if (validFiles_1.length > 0) {
                if (multiple) {
                    setSelectedFiles(function (prev) { return __spreadArray(__spreadArray([], prev, true), validFiles_1, true); });
                }
                else {
                    setSelectedFiles([validFiles_1[0]]);
                }
            }
            if (!hasError) {
                setFileError(null);
            }
        }
    };
    var handleDrop = function (e) {
        e.preventDefault();
        if (e.dataTransfer.files) {
            var filesArray = Array.from(e.dataTransfer.files);
            var filesToProcess = multiple ? filesArray : [filesArray[0]];
            var validFiles_2 = [];
            var hasError = false;
            for (var _i = 0, filesToProcess_1 = filesToProcess; _i < filesToProcess_1.length; _i++) {
                var file = filesToProcess_1[_i];
                if (file && validateFile(file)) {
                    validFiles_2.push(file);
                }
                else if (file) {
                    hasError = true;
                }
            }
            if (validFiles_2.length > 0) {
                if (multiple) {
                    setSelectedFiles(function (prev) { return __spreadArray(__spreadArray([], prev, true), validFiles_2, true); });
                }
                else {
                    setSelectedFiles([validFiles_2[0]]);
                }
            }
            if (!hasError) {
                setFileError(null);
            }
        }
    };
    var handleRemoveFile = function (index) {
        setSelectedFiles(function (prev) { return prev.filter(function (_, i) { return i !== index; }); });
    };
    var handleUpload = function () {
        setIsUploading(true);
        var onSuccess = function () {
            setIsUploading(false);
            setShowSuccess(true);
        };
        var onError = function () {
            setIsUploading(false);
        };
        onUpload(selectedFiles, docType, onSuccess, onError);
    };
    var handleClose = function () {
        if (isUploading)
            return;
        setShowSuccess(false);
        setFileError(null);
        setSelectedFiles([]);
        setDocType('');
        onClose();
    };
    return (React.createElement(Dialog, { open: open, onClose: function (_event, reason) { if (reason !== 'backdropClick')
            handleClose(); }, maxWidth: "sm", fullWidth: true },
        React.createElement(DialogTitle, { sx: { borderBottom: "1px solid #DADADA", display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 } },
            React.createElement(Typography, { fontWeight: 600, fontSize: 20 }, dialogTitle),
            React.createElement(IconButton, { onClick: handleClose, size: "small" },
                React.createElement(CloseIcon, null))),
        React.createElement(DialogContent, { sx: { minHeight: showSuccess || isUploading ? '220px' : undefined, display: 'flex', flexDirection: 'column', alignItems: 'center' } },
            isUploading ? (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' } },
                React.createElement(Box, { sx: { mb: 2 } },
                    React.createElement("svg", { width: "56", height: "56", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
                        React.createElement("circle", { cx: "12", cy: "12", r: "10", stroke: "#1976d2", strokeWidth: "2", fill: "none", strokeLinecap: "round" },
                            React.createElement("animate", { attributeName: "stroke-dasharray", values: "1,150;90,150;90,150", keyTimes: "0;0.5;1", dur: "1.5s", repeatCount: "indefinite" }),
                            React.createElement("animate", { attributeName: "stroke-dashoffset", values: "0;-35;-124", keyTimes: "0;0.5;1", dur: "1.5s", repeatCount: "indefinite" }),
                            React.createElement("animateTransform", { attributeName: "transform", type: "rotate", from: "0 12 12", to: "360 12 12", dur: "1.5s", repeatCount: "indefinite" })))),
                React.createElement(Typography, { fontWeight: 600, fontSize: 18, align: "center", mb: 1 }, "Uploading..."),
                React.createElement(Typography, { fontSize: 15, color: "#1F275C", align: "center" }, "Please wait while your files are being uploaded."))) : showSuccess ? (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' } },
                React.createElement(Box, { sx: { mb: 2 } },
                    React.createElement(SuccessCheckIcon, { sx: { fontSize: 56 } })),
                React.createElement(Typography, { fontWeight: 700, fontSize: 18, align: "center", mb: 1 }, successTitle),
                React.createElement(Typography, { fontSize: 15, color: "#1F275C", align: "center" }, successMessage))) : (React.createElement(Box, { sx: {
                    border: '1px dashed #DADADA',
                    borderRadius: 2,
                    p: 3,
                    mb: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: '#fafafa',
                    cursor: 'pointer',
                    boxSizing: 'border-box',
                    width: '100%',
                }, onDrop: handleDrop, onDragOver: function (e) { return e.preventDefault(); } },
                selectedFiles.length > 0 ? (React.createElement(Box, { sx: { mb: 1 } },
                    React.createElement("svg", { width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        React.createElement("circle", { cx: "20", cy: "20", r: "20", fill: "#0D9489" }),
                        React.createElement("path", { d: "M12 21.5L18 27.5L28 15.5", stroke: "#fff", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" })))) : (React.createElement(Box, { sx: { display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 1 } },
                    React.createElement(UploadIcon, { sx: { fontSize: 32, color: '#A0A4AB' } }))),
                selectedFiles.length > 0 ? (React.createElement(React.Fragment, null,
                    React.createElement(Typography, { mb: 0.5, fontWeight: 500 }, "Successfully Selected"),
                    multiple ? (React.createElement(Typography, { variant: "body2", color: "primary", mb: 1 },
                        selectedFiles.length,
                        " file",
                        selectedFiles.length > 1 ? 's' : '',
                        " selected")) : (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 } },
                        React.createElement(Typography, { variant: "body2", color: "primary", sx: { maxWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } },
                            "selected: ", (_b = selectedFiles[0]) === null || _b === void 0 ? void 0 :
                            _b.name))),
                    multiple ? (React.createElement(Typography, { mb: 1 }, "To add more, drag and drop your files here")) : (React.createElement(Typography, { mb: 1 }, "Drag and drop a new file to replace")))) : fileError ? (React.createElement(React.Fragment, null,
                    React.createElement(Typography, { variant: "body2", color: "error", mb: 1 }, fileError),
                    React.createElement(Typography, { mb: 1 },
                        "Drag and drop your file",
                        multiple ? 's' : '',
                        " here"))) : (React.createElement(Typography, { mb: 1 },
                    "Drag and drop your file",
                    multiple ? 's' : '',
                    " here")),
                React.createElement(Typography, { mb: 2 }, "or"),
                React.createElement(Button, { variant: "outlined", component: "label", sx: { mb: 1, color: '#3B4252', borderColor: '#DADADA', backgroundColor: '#fff', fontWeight: 500, fontSize: 16, boxShadow: 'none', borderRadius: '6px', '&:hover': { backgroundColor: '#f5f5f5', borderColor: '#DADADA' } } },
                    "Browse Files",
                    React.createElement("input", { type: "file", hidden: true, multiple: multiple, onChange: handleFileChange, accept: allowedExtensions.map(function (ext) { return ".".concat(ext); }).join(', ') })),
                React.createElement(Typography, { variant: "caption", color: "textSecondary", mb: 1 },
                    "Supported formats: ",
                    supportedFormatsText,
                    " (Max 25MB)"))),
            !showSuccess && !isUploading && multiple && selectedFiles.length > 0 && (React.createElement(Box, { sx: { mt: 2, width: '100%', maxHeight: '200px', overflowY: 'auto' } }, selectedFiles.map(function (file, index) { return (React.createElement(Box, { key: index, sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    p: 1.5,
                    mb: 1,
                    bgcolor: '#f5f5f5',
                    borderRadius: 1,
                    border: '1px solid #e0e0e0',
                } },
                React.createElement(Typography, { variant: "body2", sx: { flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } },
                    file.name,
                    " (",
                    (file.size / 1024 / 1024).toFixed(2),
                    " MB)"),
                React.createElement(IconButton, { size: "small", onClick: function () { return handleRemoveFile(index); }, sx: { ml: 1 } },
                    React.createElement(CloseIcon, { fontSize: "small" })))); }))),
            !showSuccess && !isUploading && showDocumentType && (React.createElement(Box, { sx: { mt: 2, boxSizing: "border-box", width: "100%" } },
                React.createElement(SelectDD, { options: documentTypes, labelKey: "label", valueKey: "value", DropDownLabel: "Document Type", selectedValue: docType, handleChange: function (e) { return setDocType(e.target.value); }, placeHolder: "Select document type", isMandatoryField: true })))),
        !showSuccess && !isUploading && (React.createElement(DialogActions, { sx: { px: 3, py: 3, borderTop: "1px solid #DADADA", bgcolor: '#fafafa' } },
            React.createElement(Button, { onClick: handleClose, variant: "outlined", disabled: isUploading }, cancelButtonLabel),
            React.createElement(Button, { onClick: handleUpload, variant: "contained", disabled: isUploading || selectedFiles.length === 0 || (showDocumentType && (!docType || docType === "")), sx: { textTransform: 'none', fontWeight: 500, fontSize: 16, borderRadius: '4px', boxShadow: 'none', } }, uploadButtonLabel)))));
};
export default UploadDocumentDialog;
